module.exports = __webpack_public_path__ + "img/logo_xhs.ccc5d8a9.png";